import { useDispatch, useSelector } from "react-redux";
import {
  Education,
  EvmcType,
  Living,
  ReferenceSelection,
  SocialCategory,
} from "../../models/EvmcSelections";
import { SelectedAge } from "../../models/SelectedAge";
import {
  getEvmcCategoryAgeFilterState,
  getEvmcCategorySocialCategoryFilterState,
  getEvmcEducationAgeFilterState,
  getEvmcEducationEducationFilterState,
  getEvmcLivingAgeFilterState,
  getEvmcLivingLivingFilterState,
} from "../../redux/selectors/filterSelector";
import { FilterAction } from "../../redux/states/filterState";
import AgeFilterComponent, {
  OtherAgeElementType,
} from "./components/ageFilterComponent";
import ReferenceFilterComponent from "./components/referenceFilterComponent";
import "./filterWrapperStyle.css";

export type Props = {
  type: EvmcType;
};

const EvmcFiltersWrapper: React.FC<Props> = ({ type }) => {
  const dispatch = useDispatch();
  const getAgeFilter = () => {
    switch (type) {
      case EvmcType.CATEGORY:
        return getEvmcCategoryAgeFilterState;
      case EvmcType.EDUCATION:
        return getEvmcEducationAgeFilterState;
      default:
        return getEvmcLivingAgeFilterState;
    }
  };
  const ageFilter = useSelector(getAgeFilter());
  const livingFilter = useSelector(getEvmcLivingLivingFilterState);
  const educationFilter = useSelector(
    getEvmcEducationEducationFilterState
  );
  const socialCategoryFilter = useSelector(
    getEvmcCategorySocialCategoryFilterState
  );

  const getReferenceFilter = () => {
    switch (type) {
      case EvmcType.CATEGORY:
        return (
          <ReferenceFilterComponent<SocialCategory>
            selection={socialCategoryFilter}
            setSelectionHandler={(
              selection: ReferenceSelection<SocialCategory>
            ) =>
              dispatch(
                FilterAction.SetEvmcCategorySocialCategorySelection(
                  selection
                )
              )
            }
            values={Object.values(SocialCategory)}
            type={EvmcType.CATEGORY}
          />
        );
      case EvmcType.EDUCATION:
        return (
          <ReferenceFilterComponent<Education>
            selection={educationFilter}
            setSelectionHandler={(
              selection: ReferenceSelection<Education>
            ) =>
              dispatch(
                FilterAction.SetEvmcEducationEducationSelection(
                  selection
                )
              )
            }
            values={Object.values(Education)}
            type={EvmcType.EDUCATION}
          />
        );
      default:
        return (
          <ReferenceFilterComponent<Living>
            selection={livingFilter}
            setSelectionHandler={(
              selection: ReferenceSelection<Living>
            ) =>
              dispatch(
                FilterAction.SetEvmcLivingLivingSelection(selection)
              )
            }
            values={Object.values(Living)}
            type={EvmcType.LIVING}
          />
        );
    }
  };

  const getAgeSelectionSetter = () => {
    switch (type) {
      case EvmcType.CATEGORY:
        return FilterAction.SetEvmcCategoryAgeSelection;
      case EvmcType.EDUCATION:
        return FilterAction.SetEvmcEducationAgeSelection;
      default:
        return FilterAction.SetEvmcLivingAgeSelection;
    }
  };

  const getCustomAgeSelectionSetter = () => {
    switch (type) {
      case EvmcType.CATEGORY:
        return FilterAction.SetEvmcCategoryCustomSelectedAge;
      case EvmcType.EDUCATION:
        return FilterAction.SetEvmcEducationCustomSelectedAge;
      default:
        return FilterAction.SetEvmcLivingCustomSelectedAge;
    }
  };

  const onSetAgeSelectionHandler = (selection: SelectedAge) => {
    dispatch(getAgeSelectionSetter()(selection));
  };
  const onSetCustomAge = (age: number) => {
    dispatch(getCustomAgeSelectionSetter()(age));
  };

  return (
    <>
      <AgeFilterComponent
        selectedAge={ageFilter.seletedAge}
        customAgeElement={OtherAgeElementType.customElement}
        customSelectedAge={ageFilter.customSelectedAge}
        onSetCustomAge={onSetCustomAge}
        onSetSelection={onSetAgeSelectionHandler}
        minAgeIs35={type !== EvmcType.LIVING}
        presetAge={ageFilter.seletedAge}
      />
      {getReferenceFilter()}
    </>
  );
};

export default EvmcFiltersWrapper;
